import request from '@/config/request.js'
import common from '@/components/common/'
const ApiOrder = request.Order
const ApiTeacherAssessment = request.teacherAssessment
const ApiStudentManagement = request.StudentManagement
import moment from 'moment';
import html2canvas from 'html2canvas';
export default {
  name: 'order-management',
  components: {
    ...common,
  },
  data () {
    // const changeStudent = (rule, value, callback) => {
    //   if (value === '') {
    //     callback(new Error('请选择学生'))
    //   } else if (this.orderDetails.zoneStudent.studentId === '') {
    //     callback(new Error('请选择学生!'))
    //   } else {
    //     callback()
    //   }
    // }
    const checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入手机号码！'))
      } else {
        var reg = /^1(3|4|5|6|7|8|9)\d{9}$/
        if (reg.test(value) === false) {
          callback(new Error('请输入正确的手机号码'))
        } else {
          callback()
        }
      }
    }
    const checkMoney = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入缴费金额'))
      } else {
        var reg = /(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]{1}[0-9]*$)/
        if (reg.test(value) === false) {
          callback(new Error('请输入正确的缴费金额'))
        } else {
          callback()
        }
      }
    }
    const checkRefundAmount = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入退费金额'))
      } else {
        var reg = /(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]{1}[0-9]*$)/
        if (reg.test(value) === false) {
          callback(new Error('请输入正确的退费金额'))
        } else {
          callback()
        }
      }
    }
    const checkServer = (rule, value, callback) => {
      if (this.orderDetails.servicesArr.length === 0 ) {
        callback(new Error('请至少选择一种服务'))
      } else {
        if (this.orderDetails.servicesArr.length === 1 && this.orderDetails.servicesArr[0] === '其他') {
          if (this.orderDetails.serviceNote === "") {
            callback(new Error('请填写其他相关服务'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
    }
    const checkTime = (rule, value, callback) => {
      if (this.orderDetails.serviceStart === '' || this.orderDetails.serviceEnd === '') {
        callback(new Error('请选择服务起止时间'))
      } else {
        let end = this.orderDetails.serviceEnd
        let str = this.orderDetails.serviceStart
        end = Date.parse(end)
        str = new Date(str)
        const str1 = str.getTime()
        if (str1 > end) {
          callback(new Error('开始时间不能大于结束时间'))
        } else {
          callback()
        }
        // if (end > str.setMonth(str.getMonth() + 3)) {
        //   callback(new Error('单笔订单服务时间最多不超过三个月'))
        // } else if (str1 > end) {
        //   callback(new Error('开始时间不能大于结束时间'))
        // } else {
        //   callback()
        // }
      }
    }
    return {
      downLoading: false,
      apiCode: JSON.parse(this.$store.state.login.zoneTeacher).schoolZone.apiCode,
      loadtext: '正在加载中',
      search_data: {
        filters: [{
          field: 'zoneStudent.student.grade',
          operator: 'eq',
          value: ''
        }, {
          field: 'zoneStudent.student.studentName',
          operator: 'like',
          value: ''
        }, {
          field: 'payTime',
          operator: 'ge',
          value: ''
        }, {
          field: 'serviceCategory',
          operator: 'like',
          value: ''
        }, {
          field: 'orderStatus',
          operator: 'eq',
          value: ''
        }, {
          field: 'payTime',
          operator: 'le',
          value: ''
        }, {
          field: 'zoneTeacher.teacherId',
          operator: 'eq',
          value: ''
        }, {
          field: 'paymentMethod',
          operator: 'eq',
          value: ''
        }]
      },
      payTime: [moment().startOf('month').format('YYYY-MM-DD'), moment().endOf('month').format('YYYY-MM-DD')],
      seachShow: false,
      // 需要给分页组件传的信息
      paginations: {
        current_page: parseInt(this.$route.query.page) || 1,
        total: 0,
        page_size: 10,
        page_sizes: [10, 20, 30],
        layout: 'total, sizes, prev, pager, next, jumper'
      },
      tableList: [],
      services: [
        {
          label: '午托',
          value: 'MORNING'
        }, {
          label: '下午托',
          value: 'AFTERNOON'
        }, {
          label: '作业托',
          value: 'WORK'
        }, {
          label: '其他',
          value: 'OTHER'
        }
      ],
      orderStatus: [
        {
          label: '正常',
          value: 1
        }, {
          label: '即将过期',
          value: 2
        }, {
          label: '已到期',
          value: 3
        }
      ],
      paymentMethodList: [
        {
          name: '刷卡',
          value: '刷卡'
        },
        {
          name: '转账',
          value: '转账'
        },
        {
          name: '扫码',
          value: '扫码'
        },
        {
          name: '现金',
          value: '现金'
        },
        {
          name: '抖音',
          value: '抖音'
        },
        {
          name: '美团',
          value: '美团'
        },
      ],
      refundTypeList: [
        {
          name: '全部退款',
          value: 0
        },
        {
          name: '部分退款',
          value: 1
        }
      ],
      serviceCategoryList: [
        {
          // 托管服务、寒假托、暑假托、幼儿托、周末托、兴趣课、营队活动
          name: '托管服务',
          value: '托管服务'
        },
        {
          name: '寒假托',
          value: '寒假托'
        },
        {
          name: '暑假托',
          value: '暑假托'
        },
        {
          name: '幼儿托',
          value: '幼儿托'
        },
        {
          name: '周末托',
          value: '周末托'
        },
        {
          name: '素养课',
          value: '素养课'
        },
        {
          name: '营队活动',
          value: '营队活动'
        },
        {
          name: '其他',
          value: '其他'
        }
      ],
      // 中途退托（无需求）、中途退托（转项）、请假考勤退费、未续费退定金、对服务不满意、转校或升学、活动/课程取消、学生劝退、其他
      refundReasonTagOptions: [
        {
          name: '中途退托（无需求）',
          value: '中途退托（无需求）'
        },
        {
          name: '中途退托（转项）',
          value: '中途退托（转项）'
        },
        {
          name: '请假考勤退费',
          value: '请假考勤退费'
        },
        {
          name: '未续费退定金',
          value: '未续费退定金'
        },
        {
          name: '对服务不满意',
          value: '对服务不满意'
        },
        {
          name: '转校或升学',
          value: '转校或升学'
        },
        {
          name: '活动/课程取消',
          value: '活动/课程取消'
        },
        {
          name: '学生劝退',
          value: '学生劝退'
        },
        {
          name: '其他',
          value: '其他'
        }
      ],
      paymentTagList: [
        {
          name: '全款',
          value: 'FULL'
        },
        {
          name: '定金',
          value: 'DEPOSIT'
        },
        {
          name: '尾款',
          value: 'FINAL'
        },
      ],
      grade: [
        {
          name: '一年级',
          value: 'FIRST_GRADE'
        },
        {
          name: '二年级',
          value: 'SECOND_GRADE'
        },
        {
          name: '三年级',
          value: 'THIRD_GRADE'
        },
        {
          name: '四年级',
          value: 'FOURTH_GRADE'
        },
        {
          name: '五年级',
          value: 'FIFTH_GRADE'
        },
        {
          name: '六年级',
          value: 'SIXTH_GRADE'
        },
        {
          name: '七年级',
          value: 'SEVENTH_GRADE'
        },
        {
          name: '八年级',
          value: 'EIGHTH_GRADE'
        },
        {
          name: '九年级',
          value: 'NINTH_GRADE'
        },
        {
          name: '幼小',
          value: 'YOUNG_CONNECTION'
        },
        {
          name: '其他',
          value: 'OTHER'
        }
      ],
      exportDailog: false,
      exportTime: {
        startDate: '',
        endDate: '',
        type: '缴费订单'
      },
      exportRules: {
        startDate: [
          { required: true, message: '请选择开始时间', trigger: 'change' }
        ],
        endDate: [
          { required: true, message: '请选择结束时间', trigger: 'change' }
        ]
      },
      details: {
        zoneStudent: {
          student: {
            studentName: ''
          }
        },
        zoneTeacher: {
          teacher: {
            teacherName: ''
          }
        },
        // studyClass: {
        //   studyClassName: ''
        // }
      },
      DetailFormVisible: false,
      orderDetails: {
        orderId: '',
        zoneStudent: {
          studentId: ''
        },
        studentIds: [],
        // studyClass: {
        //   studyClassId: ''
        // },
        mobile: '',
        total: '',
        paymentMethod: '',
        paymentTag: '',
        payTime: '',
        services: '',
        serviceNote: '',
        serviceStart: '',
        serviceEnd: '',
        zoneTeacher: {
          teacherId: ''
        },
        servicesArr: [],
        note: '',
        serviceCategory: ''
      },
      tfOrderDetails: {
        orderCode: '',
        zoneStudent: {
          studentId: '',
          student: {
            studentName: ''
          }
        },
        // studyClass: {
        //   studyClassId: ''
        // },
        total: '',
        refundType: ''
      },
      studentRefundForm: {
        studentOrder: {},
        refundReason: '',
        refundAmount: '',
        refundMethod: '',
        bankAccount: '',
        bank: '',
        accountHolder: '',
        otherAccounts: '',
        serviceTime: '',
        studentLeave: false,
        refundReasonTag: ''
      },
      orderRules: {
        'studyClass.studyClassId': [
          { required: true, message: '请选择所在班级', trigger: 'change' }
        ],
        'zoneStudent.studentId': [
          { required: true, message: '请选择开通服务的学生', trigger: 'change' }
        ],
        'studentIds': [
          { required: true, message: '请选择开通服务的学生', trigger: 'change' }
        ],
        serviceCategory: [
          { required: true, message: '请选择订单服务类别', trigger: 'change' }
        ],
        mobile: [
          { required: true, validator: checkPhone, trigger: 'blur' }
        ],
        total: [
          { required: true, validator: checkMoney, trigger: 'blur' }
        ],
        paymentMethod: [
          { required: true, message: '请选择收款渠道', trigger: 'change' }
        ],
        paymentTag: [
          { required: true, message: '请选择交款方式', trigger: 'change' }
        ],
        payTime: [
          { required: true, message: '请选择缴费时间', trigger: 'change' }
        ],
        changeServices: [
          { required: true, validator: checkServer, trigger: 'blur' }
        ],
        changeData: [
          { required: true, validator: checkTime, trigger: 'change' }
        ],
        'zoneTeacher.teacherId': [
          { required: true, message: '请选择经办人', trigger: 'change' }
        ],
        note: [
          { required: false, message: '请输入需要备注的内容', trigger: 'blur' }
        ]
      },
      orderTFRules: {
        refundAmount: [
          { required: true, validator: checkRefundAmount, trigger: 'blur' }
        ],
        refundReason: [
          { required: true, message: '请输入备注', trigger: 'blur' }
        ],
        refundReasonTag: [
          { required: true, message: '请选择退费原因', trigger: 'change' }
        ],
        refundMethod: [
          { required: true, message: '请选择退款方式', trigger: 'change' }
        ],
        serviceTime: [
          { required: true, message: '请选择服务时间', trigger: 'change' }
        ],
      },
      formLabelWidth: '120px',
      edit: 'add',
      studyClass: [],
      zoneStudent: [],
      zoneTeacher: [],
      pickerOptions: {
        disabledDate (time) {
          const nowdate = new Date()
          return time.getTime() > nowdate.setMonth(nowdate.getMonth() + 3)
        }
      },
      DetailVisible: false,
      PrintVisible: false,
      printMe: {
        id: 'printMe',
        popTitle: '订单回执打印',
        extraClass: './index.less/index.css',
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
      },
      printDetails: {
        zoneStudent: {
          student: {
            studentName: ''
          }
        },
        // studyClass: {
        //   studyClassName: ''
        // },
        zoneTeacher: {
          teacher: {
            teacherName: ''
          }
        }
      },
      moneyCheck: {
        0: '零',
        1: '壹',
        2: '贰',
        3: '叁',
        4: '肆',
        5: '伍',
        6: '陆',
        7: '柒',
        8: '捌',
        9: '玖'
      },
      userInfo: JSON.parse(this.$store.state.login.userInfo),
      bgUrl: require('../../../../assets/print/logo.png'),
      DetailTFFormVisible: false,
      editTFFormVisible: false,
      paymentAmount: [],
      refundAmount: [],
      getOnliyStudent: [],

      schoolsInfo: null,
    }
  },
  computed: {
    tableHight: function () {
      return window.innerHeight - 255
    },
    loading: function () {
      return this.$store.state.global.ajax_loading
    }
  },
  methods: {
    getStatusString (data, value) {
      for (let j = 0; j < this[data].length; j++) {
        if (this[data][j].value === value) {
          return this[data][j].name
        }
      }
    },
    getExpiryDate (key) {
      this.orderDetails.serviceEnd = ''
      if( this.edit === 'add') {
        if (key && key.length === 1) {
              this.zoneStudent.map(item=> {
              if (key.includes(item.studentId) && item.expiryDate && this.orderDetails.serviceCategory === '托管服务') {
                this.orderDetails.serviceEnd = item.expiryDate
              }
            })
        }
      } else {
        this.zoneStudent.map(item=> {
          if (item.studentId === key && item.expiryDate && this.orderDetails.serviceCategory === '托管服务') {
            this.orderDetails.serviceEnd = item.expiryDate
          }
        })
      }
      
      
    },
    getExpiryStudentDate (key) {
      this.orderDetails.serviceEnd = ''
      if (this.edit === 'add') {
        if (this.orderDetails.studentIds && key === '托管服务') {
          let ids = this.orderDetails.studentIds
          if (ids && ids.length === 1) {
            this.zoneStudent.map(item=> {
              if (item.studentId === ids[0] && item.expiryDate) {
                this.orderDetails.serviceEnd = item.expiryDate
              }
            })
          }
        }
      } else {
        if (this.orderDetails.studentIds && key === '托管服务') {
          let ids = this.orderDetails.zoneStudent.studentId
          this.zoneStudent.map(item=> {
              if (item.studentId === ids && item.expiryDate) {
                this.orderDetails.serviceEnd = item.expiryDate
              }
            })
          
        }
      }
      
    },
    getPayTime () {
      this.search_data.filters[2].value = this.payTime[0]
      this.search_data.filters[5].value = this.payTime[1]
    },
    /*
    * 获取当前系统时间
    * */
    getNowTime () {
      var now = new Date()
      var year = now.getFullYear()
      var month = now.getMonth()
      var date = now.getDate()
      var Hours = now.getHours()
      var Minutes = now.getMinutes()
      var Seconds = now.getSeconds()
      month = month + 1
      if (month < 10) month = '0' + month
      if (date < 10) date = '0' + date
      if (Hours < 10) Hours = '0' + Hours
      if (Minutes < 10) Minutes = '0' + Minutes
      if (Seconds < 10) Seconds = '0' + Seconds
      return year + '-' + month + '-' + date + ' ' + Hours + ':' + Minutes + ':' + Seconds
    },
    /*
    * 小写转换
    * */
    getMoneyBig (num) {
      return this.moneyCheck[num]
    },
    getStringSub (str, bl, index) {
      if (str) {
        str = str + ''
        const arr = str.split('.')
        if (bl > 0) {
          if (index >= arr[0].length) {
            return '\\'
          } else {
            return this.getMoneyBig(arr[0][arr[0].length - index - 1])
          }
        } else {
          if (arr.length > 1) {
            if (index >= arr[1].length) {
              return '零'
            } else {
              return this.getMoneyBig(arr[1][index])
            }
          } else {
            return '零'
          }
        }
      }
    },
    /*
    * onPrint 打印
    * */
    onPrint () {
      // this.$print(this.$refs.printMe)
      const tabStyle = `<style>
          #printMe{
            color: #999;
            position: relative;
          }
          .p-title{
          display: flex;
          justify-content: center;
          font-size: 30px;
          font-family: 新宋体;
          font-weight: bolder;
          letter-spacing: 8px;
          text-align: center;
          }
          table {
            border-top: 1px solid #999;
            border-left: 1px solid #999;
            border-spacing: 0;
            flex: 1;
          }
          tr{
            height: 40px;
          }
          th{
           word-break: break-all;
            padding: 10px;
            border-bottom: 1px solid #999;
            border-right: 1px solid #999;
            height: 50px;
            font-size: 16px;
            text-align: center;
          }
          td {
            word-break: break-all;
            padding: 10px;
            border-bottom: 1px solid #999;
            border-right: 1px solid #999;
            /*min-width: 58px;*/
            height: 17px;
            font-size: 13px;
            text-align: center;
          }
           td .s-text{
            display: inline-block;
            width: 28px;
            text-align: center;
            font-size: 16px;
            }
           td .s-text.s-end{
              width: 70px;
            }
            td.beizhu{
            height: 120px;
            }
          </style><body>`
      this.getBase64(
        (this.schoolsInfo.zoneTeacher.schoolZone.zoneBrand || this.schoolsInfo.zoneTeacher.schoolZone.brand) === 'BRAND_YN' ?
        require('../../../../assets/print/YN.png') :
        ((this.schoolsInfo.zoneTeacher.schoolZone.zoneBrand || this.schoolsInfo.zoneTeacher.schoolZone.brand) === 'BRAND_QN' ?
          require('../../../../assets/print/logo.png') :
          require('../../../../assets/print/logo.png')), list => {
        this.getBase64(require('../../../../assets/print/yz.png'), list1 => {

          var imgs = document.getElementsByClassName('imgBg')[0]
          var imgs1 = document.getElementsByClassName('imgYz')[0]
          imgs.setAttribute('src', list)
          imgs.setAttribute('style', 'display: block;position: absolute;top: 0px;left: 0px;width: 180px')
          imgs1.setAttribute('src', list1)
          imgs1.setAttribute('style', 'display: block;position: absolute;top: -50px;right: 0;width: 140px')
          this.$nextTick(() => {
            const printForm = this.$refs.printMe.innerHTML
            const printStr = "<html><head><meta http-equiv='Content-Type' content='text/html; charset=utf-8'></head>"
            const printPart1 = printStr + tabStyle + '</body></html>'
            const printPart = printPart1 + printForm
            const newTab = window.open('_blank')
            newTab.document.body.innerHTML = printPart
            newTab.print()
            newTab.close()
          })
        })
      })
    },
    getBase64 (url, callback) {
      const Img = new Image()
      let dataURL = ''
      Img.src = url + '?v=' + Math.random()
      Img.setAttribute('crossOrigin', 'Anonymous') // 解决控制台跨域报错的问题（没用就跟后台沟通添加跨域）
      Img.onload = function () { // 要先确保图片完整获取到，这是个异步事件
        const canvas = document.createElement('canvas') // 创建canvas元素
        const width = Img.width // 确保canvas的尺寸和图片一样
        const height = Img.height
        canvas.width = width
        canvas.height = height
        canvas.getContext('2d').drawImage(Img, 0, 0, width, height) // 将图片绘制到canvas中
        dataURL = canvas.toDataURL('image/' + url) // 转换图片为dataURL
        callback(dataURL)
      }
    },
    // 辅助方法：获取品牌名称（复用原有收据标题逻辑）
    getBrandName() {
      const brand = this.schoolsInfo.zoneTeacher.schoolZone.zoneBrand || this.schoolsInfo.zoneTeacher.schoolZone.brand;
      switch (brand) {
        case 'BRAND_YN':
          return '贝尔优能';
        case 'BRAND_QN':
          return '贝尔全能';
        default:
          return '贝尔安亲';
      }
    },
    // 新增：下载为图片方法
    async handleDownloadImage() {
      this.downLoading = true
      try {
        // 1. 获取需要转为图片的DOM元素（打印预览区域）
        const printDom = document.getElementById('downMe');

        // 2. 配置html2canvas（解决图片跨域、样式丢失问题）
        const canvas = await html2canvas(printDom, {
          useCORS: true, // 允许跨域图片（若预览中有外部图片需开启）
          allowTaint: false, // 禁止污染Canvas（避免导出失败）
          scale: 2, // 缩放比例（2倍缩放，保证图片清晰度）
          logging: false, // 关闭控制台日志
          backgroundColor: '#ffffff', // 背景色（避免透明）
          windowWidth: printDom.offsetWidth, // 适配DOM宽度
          windowHeight: printDom.offsetHeight // 适配DOM高度
        });

        // 3. 将Canvas转为图片URL（支持png/jpeg格式）
        const imageUrl = canvas.toDataURL('image/png'); // 若要更小体积，可改为 'image/jpeg'

        // 4. 创建下载链接，触发浏览器下载
        const link = document.createElement('a');
        link.href = imageUrl;
        // 下载文件名（包含订单号，便于区分）
        const fileName = `${this.getBrandName()}收据_${this.printDetails.orderCode}.png`;
        link.download = fileName;
        // 模拟点击下载
        document.body.appendChild(link);
        link.click();
        // 下载后移除临时链接
        document.body.removeChild(link);

        // （可选）提示下载成功
        this.$message.success('图片下载成功！');
        this.downLoading = false
      } catch (error) {
        // 捕获异常，提示用户
        this.downLoading = false
        console.error('图片下载失败：', error);
        this.$message.error('图片下载失败，请重试！');
      }
    },
    /*
     * 打印预览
     * */
    onPrintShow (row) {
      this.printDetails = {
        zoneStudent: {
          student: {
            studentName: ''
          }
        },
        // studyClass: {
        //   studyClassName: ''
        // },
        zoneTeacher: {
          teacher: {
            teacherName: ''
          }
        }
      }
      this.printDetails = Object.assign({}, row)
      this.printDetails.paymentMethod = this.printDetails.paymentMethod ? [this.printDetails.paymentMethod] : []
      this.PrintVisible = true
    },
    /*
    * 发送短信提醒
    * */
    expirationReminder (id) {
      ApiOrder.expirationReminder.call(this, { orderId: id }, (item) => {
      })
    },
    getDetails (item) {
      this.DetailVisible = true
      this.details = Object.assign(this.details, item)
    },
    deepClone(obj){
      let objClone =  Array.isArray(obj) ? [] : {};
      if (obj && typeof obj === 'object') {
        for(let key in obj){
          if (obj[key] && typeof obj[key] === 'object'){
            objClone[key] = this.deepClone(obj[key]);
          }else{
            objClone[key] = obj[key]
          }
        }
      }
      return objClone;
    },
    getRowDetails (item) {
      let row = this.deepClone({...item})
      this.edit = 'edit'
      // this.getStudyClassByZoneId(item.studyClass.studyClassId)
      this.getzoneTeacher()
      var data = {
        offset: 1,
        limit: 1000,
        data: {
          expiryRange:  "ALREADY_EXPIRY",
          isLeave: false,
          studentCondition: "NORMAL"
        },
        filters: null,
        orFilters: null,
        order: 'desc',
        sort: 'studentId'
      }
      ApiStudentManagement.getStudentList.call(this, data, (listData) => {
        this.zoneStudent = listData.content
      })

      if (row.services !== '') {
        const strArr = []
        row.services = row.services.split(',')
        for (let j = 0; j < row.services.length; j++) {
          for (let i = 0; i < this.services.length; i++) {
            if (row.services[j] === this.services[i].value) {
              strArr.push(this.services[i].label)
            }
          }
        }
        row.servicesArr = strArr
        row.services = ''
      }
      this.orderDetails = Object.assign({...this.orderDetails}, {...row})
      // console.log(this.orderDetails, row, '=======')
      // this.orderDetails.studentId = this.orderDetails.zoneStudent?.studentId
      // console.log(this.orderDetails)
      this.$nextTick(() => {
        this.DetailFormVisible = true
      })
    },
    getRowTFDetails (item) {
      const row = Object.assign(this.tfOrderDetails, item)
      this.studentRefundForm.studentOrder = { orderId: item.orderId}
      this.studentRefundForm.serviceTime = row.serviceEnd
      this.DetailTFFormVisible = true
      this.tfOrderDetails = Object.assign(this.tfOrderDetails, row)
    },
    /*getEditRowTFDetails (item) {
      this.tfOrderDetails = Object.assign(this.tfOrderDetails, item.studentOrder)

      this.studentRefundForm.refundReason = item.refundReason
      this.studentRefundForm.refundAmount = item.refundAmount
      this.studentRefundForm.refundMethod = item.refundMethod
      this.studentRefundForm.bankAccount = item.bankAccount
      this.studentRefundForm.bank = item.bank
      this.studentRefundForm.accountHolder = item.accountHolder
      this.studentRefundForm.otherAccounts = item.otherAccounts
      this.studentRefundForm.formId = item.formId
      this.studentRefundForm.studentOrder = { orderId: item.studentOrder.orderId}
      this.studentRefundForm.studentLeave = item.studentLeave

     this.editTFFormVisible = true
    },*/
    expandVisible(row, rowIndex) {
         let data = row.row
         let res = []
         if (data.studentRefundForms && data.studentRefundForms.length > 0) {
               res.push('row-expand-has')
               return res
           } else {
               res.push('row-expand-cover')
               return res
           }
     },
    getDeleteRowTFDetails (item) {
      this.$confirm('是否确定删除该订单？删除后不可恢复。是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.studentRefundForm.refundReason = item.refundReason
        this.studentRefundForm.refundAmount = item.refundAmount
        this.studentRefundForm.refundMethod = item.refundMethod
        this.studentRefundForm.bankAccount = item.bankAccount
        this.studentRefundForm.bank = item.bank
        this.studentRefundForm.accountHolder = item.accountHolder
        this.studentRefundForm.otherAccounts = item.otherAccounts
        this.studentRefundForm.formId = item.formId
        this.studentRefundForm.status = 1
        this.studentRefundForm.studentOrder = { orderId: item.studentOrder.orderId}
        this.studentRefundForm.refundReasonTag = item.refundReasonTag
        // this.studentRefundForm.studentLeave = item.studentLeave
        // console.log(this.studentRefundForm, '1111')
        ApiOrder.addStudentRefundForm.call(this, this.studentRefundForm, res => {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.initData()
          this.initOrderTatol()
        })
      }).catch(() => {
      })

    },
    getzoneTeacher () {
      ApiTeacherAssessment.getZoneTeachers.call(this, {}, (item) => {
        this.zoneTeacher = item
      })
    },
    getStudyClassByZoneId (id) {
      ApiOrder.getStudyClassByZoneId.call(this, {}, (listData) => {
        this.studyClass = listData
        if (id) {
          this.studyClass.map(item => {
            if (item.studyClassId === this.orderDetails.studyClass.studyClassId) {
              if (item.studyClassZoneStudents && item.studyClassZoneStudents.length > 0) {
                this.zoneStudent = item.studyClassZoneStudents
              }
            }
          })
        }
      })
    },
    // getStudent () {
    //   this.orderDetails.zoneStudent.studentId = ''
    //   this.zoneStudent = []
    //   this.studyClass.map(item => {
    //     if (item.studyClassId === this.orderDetails.studyClass.studyClassId) {
    //       if (item.studyClassZoneStudents && item.studyClassZoneStudents.length > 0) {
    //         this.zoneStudent = item.studyClassZoneStudents
    //       }
    //     }
    //   })
    // },
    addShow (type) {
      this.DetailFormVisible = true
      this.$nextTick(() => {
        this.$refs['orderForm'].resetFields()
        this.orderDetails = {
          orderId: '',
          zoneStudent: {
            studentId: ''
          },
          studentIds: [],
          // studyClass: {
          //   studyClassId: ''
          // },
          mobile: '',
          total: '',
          payTime: '',
          services: '',
          serviceNote: '',
          serviceStart: '',
          serviceEnd: '',
          zoneTeacher: {
            teacherId: ''
          },
          servicesArr: [],
          note: '',
          paymentMethod: '',
          paymentTag: '',
          serviceCategory: ''
        }
        this.edit = type
        // this.getStudyClassByZoneId()
        // this.getzoneTeacher()

        var data = {
          offset: 1,
          limit: 1000,
          data: {
            // expiryRange:  "ALREADY_EXPIRY",
            isLeave: false,
            // studentCondition: "NORMAL"
          },
          filters: null,
          orFilters: null,
          order: 'desc',
          sort: 'studentId'
        }
        ApiStudentManagement.getStudentList.call(this, data, (listData) => {
          this.zoneStudent = listData.content
        })
      })
    },
    addTFShow () {
      this.getStudyClassByZoneId()
      this.getzoneTeacher()
      this.$nextTick(() => {
        this.DetailTFFormVisible = true
      })
    },
    onDeleteOrder (id) {
      const that = this
      this.$confirm('是否确定删除该订单？删除后不可恢复。是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ApiOrder.deleteStudentOrder.call(this, { orderId: id }, () => {
          that.initData()
          that.initOrderTatol()
        })
      }).catch(() => {
      })
    },
    onSave (formName) {
      const that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const strArr = []
          if (that.orderDetails.servicesArr.length > 0) {
            for (let j = 0; j < that.orderDetails.servicesArr.length; j++) {
              for (let i = 0; i < that.services.length; i++) {
                if (that.orderDetails.servicesArr[j] === that.services[i].label) {
                  strArr.push(that.services[i].value)
                }
              }
            }
          }
          that.orderDetails.services = strArr.join(',')
          // console.log(that.orderDetails)
          // return
          let str = 'add'
          str = this.edit === 'add' ? 'addStudentOrder' : 'updateStudentOrder'
          if (that.edit === 'add') {
            delete that.orderDetails.zoneStudent
          } else {
            delete that.orderDetails.studentIds
          }
          ApiOrder[str].call(this, that.orderDetails, res => {
            that.$message({
              message: '保存成功',
              type: 'success'
            })
            this.initData()
            this.initOrderTatol()
            this.$refs[formName].resetFields()
            this.DetailFormVisible = false
          })
        }
      })
    },
    addStudentRefundForm (formName) {
      // console.log(this.studentRefundForm)
      // return
      const that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {

          ApiOrder.addStudentRefundForm.call(this, that.studentRefundForm, res => {
            that.$message({
              message: '操作成功',
              type: 'success'
            })
            this.initData()
            this.initOrderTatol()
            this.$refs[formName].resetFields()
            this.DetailTFFormVisible = false
            this.editTFFormVisible = false
          })
        }
      })
    },
    // 取消订单新增编辑界面
    resetStudent (formName) {
      this.$refs[formName].resetFields()
      this.DetailFormVisible = false
    },
    // 关闭订单新增编辑界面
    closeOrder (formName) {
      this.$refs[formName].resetFields()
      this.orderDetails = {
        orderId: '',
        zoneStudent: {
          studentId: ''
        },
        studentIds: [],
        // studyClass: {
        //   studyClassId: ''
        // },
        mobile: '',
        total: '',
        services: '',
        serviceNote: '',
        serviceStart: '',
        serviceEnd: '',
        zoneTeacher: {
          teacherId: ''
        },
        servicesArr: [],
        note: '',
        paymentMethod: '',
        paymentTag: '',
        serviceCategory: ''
      }
      this.DetailFormVisible = false
    },
    // 关闭订单新增编辑界面
    closeTFOrder (formName) {
      this.$refs[formName].resetFields()
      this.DetailTFFormVisible = false
      this.studentRefundForm = {
        studentOrder: {},
        refundReason: '',
        refundAmount: '',
        refundMethod: '',
        bankAccount: '',
        bank: '',
        accountHolder: '',
        otherAccounts: '',
        studentLeave: false,
        refundReasonTag: ''
      }
    },
    // 关闭订单新增编辑界面
    closeEditTFOrder (formName) {
      this.$refs[formName].resetFields()
      this.studentRefundForm = {
        studentOrder: {},
        refundReason: '',
        refundAmount: '',
        refundMethod: '',
        bankAccount: '',
        bank: '',
        accountHolder: '',
        otherAccounts: '',
        studentLeave: false,
        refundReasonTag: ''
      }
      this.editTFFormVisible = false
    },
    onResetSearch () {
      this.search_data = {
        filters: [{
          field: 'zoneStudent.student.grade',
          operator: 'eq',
          value: ''
        }, {
          field: 'zoneStudent.student.studentName',
          operator: 'like',
          value: ''
        }, {
          field: 'payTime',
          operator: 'ge',
          value: ''
        }, {
          field: 'services',
          operator: 'like',
          value: ''
        }, {
          field: 'orderStatus',
          operator: 'eq',
          value: ''
        }, {
          field: 'payTime',
          operator: 'le',
          value: ''
        }, {
          field: 'zoneTeacher.teacherId',
          operator: 'eq',
          value: ''
        }]
      }
      this.payTime = [moment().startOf('month').format('YYYY-MM-DD'), moment().endOf('month').format('YYYY-MM-DD')]
      this.initData()
      this.initOrderTatol()
    },
    getorderStatus (str) {
      for (let j = 0; j < this.orderStatus.length; j++) {
        if (this.orderStatus[j].value === str) {
          return this.orderStatus[j].label
        }
      }
    },
    getServices (str) {
      if (str && str.split(',').length > 0) {
        let item = ''
        const obj = str.split(',')
        for (let i = 0; i < obj.length; i++) {
          for (let j = 0; j < this.services.length; j++) {
            if (obj[i] === this.services[j].value) {
              item += this.services[j].label + '  '
            }
          }
        }
        return item
      } else {
        return ''
      }
    },
    onExport (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {}
          data = {
            startDate: this.exportTime.startDate,
            endDate: this.exportTime.endDate,
            type: this.exportTime.type === '缴费订单'? 0 : 1
          }
          ApiOrder.exportStudentOrder.call(this, data, (res) => {
            window.open(res.result)
          })
        }
      })
    },
    getDetail (row) {
      this.DetailFormVisible = true
      this.dateDetail = row
    },
    /**
     * 搜索事件
     */
    onSearch () {
      const newQuery = {}
      this.paginations.current_page = 1
      this.$router.replace({ query: newQuery })
      var where = []
      for (var s in this.search_data.filters) {
        if (this.search_data.filters[s].value) {
          where.push(this.search_data.filters[s])
        }
      }
      // this.getList({
      //   where
      // })
      this.initData()
      this.initOrderTatol()
    },
    /**
     * 改变页码和当前页时需要拼装的路径方法
     * @param {string} field 参数字段名
     * @param {string} value 参数字段值
     */
    setPath (field, value) {
      var path = this.$route.path
      var query = Object.assign({}, this.$route.query)

      if (typeof field === 'object') {
        query = field
      } else {
        query[field] = value
      }
      this.$router.push({
        path,
        query
      })
    },
    /**
     * 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      // this.getList({
      //   page,
      //   fn: () => {
      //     this.setPath('page', page)
      //   }
      // })
      this.initData()
      this.initOrderTatol()
    },
    /**
     * 改变每页显示数量事件
     * @param  {number} size 当前每页显示数量
     */
    onChangePageSize (pageSize) {
      // this.getList({
      //   pageSize,
      //   fn: () => {
      //     this.setPath('page_size', pageSize)
      //   }
      // })
      this.initData()
    },
    initData () {
      this.listLoading = true;
      if (this.payTime && this.payTime.length > 0) {
        this.search_data.filters[2].value = this.payTime[0]
        this.search_data.filters[5].value = this.payTime[1]
      } else {
        this.search_data.filters[2].value = ''
        this.search_data.filters[5].value = ''
      }
      var data = {
        offset: (this.paginations.current_page - 1) * this.paginations.page_size,
        limit: this.paginations.page_size,
        data: null,
        filters: null,
        orFilters: null,
        order: 'desc',
        sort: 'createTime'
      }
      let search = {
        filters: []
      }
      this.search_data.filters.map(item => {
        if (item.value) {
          search.filters.push(item)
        }
      })
      let _query = {
        ...data,
        ...search,
      };
      ApiOrder.getStudentOrder.call(this,_query, (res => {
        this.tableList = res.content
        this.paginations.total = parseInt(res.totalElements)
        this.listLoading = false;
      }))
    },
    /*getList ({
      page,
      pageSize,
      where,
      fn
    } = {}) {
      var query = this.$route.query
      this.paginations.current_page = page || parseInt(query.page) || 1
      this.paginations.page_size = pageSize || parseInt(query.page_size) || this.paginations.page_size
      var data = {
        offset: (this.paginations.current_page - 1) * this.paginations.page_size,
        limit: this.paginations.page_size,
        data: null,
        filters: null,
        orFilters: null,
        order: 'desc',
        sort: 'createTime'
      }
      if (where) {
        data = Object.assign(data, { filters: where } || {})
      } else {
        var queryArr = []
        for (var s in this.search_data.filters) {
          if (this.search_data.filters[s].value) {
            queryArr.push(this.search_data.filters[s])
          }
        }
        data = Object.assign(data, { filters: queryArr } || {})
      }
      ApiOrder.getStudentOrder.call(this, data, (listData) => {
        this.tableList = listData.content
        this.paginations.total = parseInt(listData.totalElements)
        fn && fn()
      })
    },*/
    /*getStudentOrder ({
               page,
               pageSize,
               where,
               fn
             } = {}) {
      var query = this.$route.query
      this.paginations.current_page = page || parseInt(query.page) || 1
      this.paginations.page_size = pageSize || parseInt(query.page_size) || this.paginations.page_size
      var data = {
        offset: (this.paginations.current_page - 1) * this.paginations.page_size,
        limit: this.paginations.page_size,
        data: null,
        filters: null,
        orFilters: null,
        order: 'desc',
        sort: 'createTime'
      }
      if (where) {
        data = Object.assign(data, { filters: where } || {})
      } else {
        var queryArr = []
        for (var s in this.search_data.filters) {
          if (this.search_data.filters[s].value) {
            queryArr.push(this.search_data.filters[s])
          }
        }
        data = Object.assign(data, { filters: queryArr } || {})
      }
      ApiOrder.getStudentOrderAmountStatistics.call(this, data, (listData) => {
        let paymentAmount = (listData.paymentAmount+'').split('.')
        let refundAmount = (listData.refundAmount+'').split('.')
        this.paymentAmount = paymentAmount.length > 1 ? paymentAmount : [...paymentAmount, "00"]
        this.refundAmount =  refundAmount.length > 1 ? refundAmount : [...refundAmount, "00"]
      })
    },*/
    initOrderTatol () {
      if (this.payTime && this.payTime.length > 0) {
        this.search_data.filters[2].value = this.payTime[0]
        this.search_data.filters[5].value = this.payTime[1]
      } else {
        this.search_data.filters[2].value = ''
        this.search_data.filters[5].value = ''
      }
      var data = {
        offset:20000,
        limit: 0,
        data: null,
        filters: null,
        orFilters: null,
        order: 'desc',
        sort: 'createTime'
      }
      let search = {
        filters: []
      }
      this.search_data.filters.map(item => {
        if (item.value) {
          search.filters.push(item)
        }
      })
      let _query = {
        ...data,
        ...search,
      };
      ApiOrder.getStudentOrderAmountStatistics.call(this, _query, (listData) => {
        let paymentAmount = (listData.paymentAmount+'').split('.')
        let refundAmount = (listData.refundAmount+'').split('.')
        this.paymentAmount = paymentAmount.length > 1 ? paymentAmount : [...paymentAmount, "00"]
        this.refundAmount =  refundAmount.length > 1 ? refundAmount : [...refundAmount, "00"]
      })
    }
  },
  mounted () {
    this.schoolsInfo = JSON.parse(this.$store.state.login.schoolsInfo) || null
    this.initData()
    this.initOrderTatol()
    this.getzoneTeacher()
  }
}
